var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClockActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16117 6.91211C8.42185 4.62366 11.5486 3.20599 15 3.20599C18.4514 3.20599 21.5782 4.62366 23.8388 6.91211C26.0995 9.20055 27.5 12.3657 27.5 15.8595C27.5 19.3533 26.0995 22.5184 23.8388 24.8068C21.5782 27.0953 18.4514 28.5129 15 28.5129C11.5486 28.5129 8.42185 27.0953 6.16117 24.8068C3.90048 22.5184 2.5 19.3533 2.5 15.8595C2.5 12.3657 3.90048 9.20055 6.16117 6.91211ZM15 5.73668C12.2382 5.73668 9.73995 6.86833 7.92893 8.70158C6.11792 10.5348 5 13.0638 5 15.8595C5 18.6551 6.11792 21.1841 7.92893 23.0174C9.73995 24.8506 12.2382 25.9823 15 25.9823C17.7618 25.9823 20.2601 24.8506 22.0711 23.0174C23.8821 21.1841 25 18.6551 25 15.8595C25 13.0638 23.8821 10.5348 22.0711 8.70158C20.2601 6.86833 17.7618 5.73668 15 5.73668Z",
    fill: "url(#paint0_linear_1_396)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9.53273C15.6904 9.53273 16.25 10.0992 16.25 10.7981V15.8595C16.25 16.5583 15.6904 17.1248 15 17.1248C14.3096 17.1248 13.75 16.5583 13.75 15.8595L13.75 10.7981C13.75 10.0992 14.3096 9.53273 15 9.53273Z",
    fill: "url(#paint1_linear_1_396)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1161 14.9647C14.6043 14.4706 15.3957 14.4706 15.8839 14.9647L18.3839 17.4954C18.872 17.9896 18.872 18.7907 18.3839 19.2849C17.8957 19.779 17.1043 19.779 16.6161 19.2849L14.1161 16.7542C13.628 16.2601 13.628 15.4589 14.1161 14.9647Z",
    fill: "url(#paint2_linear_1_396)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_396",
    x1: 2.92049,
    y1: 3.20598,
    x2: 28.0361,
    y2: 3.74973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_396",
    x1: 16.0236,
    y1: 17.1248,
    x2: 13.7562,
    y2: 17.0433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677095,
    stopColor: "#F3D25C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_396",
    x1: 18.2972,
    y1: 19.6555,
    x2: 13.8087,
    y2: 19.1714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0BA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677095,
    stopColor: "#F3D25C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockActive);
export default __webpack_public_path__ + "static/media/icon_clock_active.b912c5211ffe0e8cdb074aa5a8e2226e.svg";
export { ForwardRef as ReactComponent };